module.exports = __webpack_public_path__ + "static/media/Visibility off.fcf59745.svg";